module.exports = __webpack_public_path__ + "assets/images/bill-my-account-active.svg";